module.exports = __webpack_public_path__ + "img/ic_mediathek.40185e5f.svg";